<div class="scroll-block simplebar-scrollable-y" data-simplebar="init">
    <div class="simplebar-wrapper" style="margin: 0px;">
        <div class="simplebar-height-auto-observer-wrapper">
            <div class="simplebar-height-auto-observer"></div>
        </div>
        <div class="simplebar-mask">
            <div class="simplebar-offset" style="right: 0px;bottom: 0px;">
                <div class="simplebar-content-wrapper overflow-auto" tabindex="0" role = 'region' aria-label="scrollable content">
                    <div class="simplebar-content" style="padding: 0px;">
                        <div class="tab-content">
                            <div class="tab-pane show active" id="prifile-1" role="tabpanel" aria-labelledby="profile-tab-1">
                                <table class="table table-borderless mb-0 mail-table"  *ngIf="data">
                                    <tbody>
                                        <tr class="unread"   *ngFor="let item of paginatedData">
                                            <td style="width:3%;">
                                                <div>
                                                    <fa-icon *ngIf="tipo.includes('Richiesta')" [icon]="faCircle" class="me-2 icone" size="1x"></fa-icon>
                                                    <fa-icon *ngIf="tipo.includes('Risultato')" [icon]="faRisultato" class="me-2 icone" size="1x"></fa-icon>

                                                </div>
                                            </td>
                                            <td  style="width:30%;">
                                                <div class="d-flex align-items-center w-100">
                                                    <div class="flex-grow-1 position-relative">
                                                        <p class="mb-0 fs-6">{{tipo}} </p>
                                                    </div>
                                                </div>
                                            </td>
                                           
                                          
                                            <td  style="width:10%;"></td>
                                            <td style="width:30%;text-align: center;">
                                                <div class="d-flex align-items-center w-100">
                                                    <div class="flex-grow-1 position-relative">
                                                        <p class="mb-0 fs-6">{{item.maxdata | date: 'dd/MM/yyyy'}} </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td  style="width:10%;" class="d-flex justify-content-center">
                                                <p-badge *ngIf="item.stato=='completata'" [value]="item.stato | titlecase" severity="success" />
                                                <p-badge *ngIf="item.stato=='lavorazione'" [value]="item.stato | titlecase" severity="warning" />
                                                <p-badge *ngIf="item.stato=='inviata'" [value]="item.stato | titlecase" />
                                            </td>
                                            <td  style="text-align: center;">
                                                <div class="d-flex align-items-center justify-content-end w-100 fs-4">
                                              <!--      <div class="flex-grow-1 position-relative">
                                                          <p  (click)="showDialog(item,tipo)" 
                                                          icon="pi pi-arrow-up-left" 
                                                          label="BottomRight" 
                                                          severity="secondary"
                                                class="text-body-secondary mb-0  link-offset-2 link-underline link-underline-opacity-0 eye"
                                                data-bs-toggle="modal" data-bs-target="#customer-modal"><fa-icon [icon]="faEye"></fa-icon>
                                                </p>                                                 
                                                    </div>
                                                    -->
                                                    <div>
                                                        <fa-icon *ngIf="tipo.includes('Richiesta') " 
                                                        class="text-body-secondary mb-0  link-offset-2 link-underline link-underline-opacity-0 eye" 
                                                        [icon]="faGoTo"
                                                        (click)="goToPage(tipo,item.composition_uid_value,item.ehrid)"
                                                        ></fa-icon>
                                                    </div>
                                                </div>
                                              </td>
                                        </tr>
                                    </tbody>
                                    <nav aria-label="Table pagination" style="background-color: transparent;">
                                        <ul class="pagination justify-content-center mt-3 " style="background-color: transparent;">
                                          <li class="page-item" [class.disabled]="currentPage === 1"  style="background-color: transparent;">
                                            <button class="page-link" (click)="previousPage()">Precedente</button>
                                          </li>
                                          <li class="page-item" style="background-color: transparent;padding-right: 0;padding-left: 0;" *ngFor="let page of [].constructor(totalPages); let i = index" [class.active]="currentPage === i + 1">
                                            <button class="page-link" (click)="goToPagina(i + 1)">{{ i + 1 }}</button>
                                          </li>
                                          <li class="page-item" style="background-color: transparent;" [class.disabled]="currentPage === totalPages">
                                            <button class="page-link" (click)="nextPage()">Successiva</button>
                                          </li>
                                        </ul>
                                      </nav>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-dialog 
       
        [modal]="true"
        [(visible)]="visible" 
        [position]="'bottom'"
        [style]="{ width: '50rem',height:'50rem'}" (onHide)="form=undefined">
        <ng-template pTemplate="header" class="justify-content-end">
            <div class="inline-flex  gap-2" style="justify-content: end;">
                <div class="col">
                    <button class="btn btn-danger rounded m-1" ><fa-icon [icon]="faDocument" (click)="downloadPDF()"></fa-icon></button>

                    <button class="btn btn-success rounded m-3" [useExistingCss]="true" printSectionId="print-section" ngxPrint><fa-icon [icon]="faPrint"></fa-icon></button>
                </div>
            </div>
        </ng-template>
   
        <div *ngIf="form && compositionId && ehrId" >
           <app-form-preview  [form]="form" [compositionId]="compositionId" [ehrId]="ehrId" #printContent></app-form-preview>
        </div>
    </p-dialog>
</div>
